import GoogleOptimizeProvider from './googleOptimizeProvider'

export * from './googleOptimizeProvider'

export default GoogleOptimizeProvider
